import isEqual from 'lodash/isEqual';
import { ExtendableListPaginationQueryArgBase, ExtendableListPaginationQueryResponseBase, ExtendableListPaginationState } from './types';

export const createStateMutation =
  <Parameters extends ExtendableListPaginationQueryArgBase, Item, ResultType extends ExtendableListPaginationQueryResponseBase<Item>>({
    parameters,
    page,
    response,
  }: {
    parameters: Parameters;
    page: number;
    response: ResultType;
  }): ((
    prevState: ExtendableListPaginationState<Parameters, Item, ResultType>,
  ) => ExtendableListPaginationState<Parameters, Item, ResultType>) =>
  (prevState) => {
    const { page: prevPage } = prevState;
    const { items, ...additionalData } = response;

    if (isEqual(prevState.parameters, parameters)) {
      if (page === 1) {
        return {
          parameters,
          items,
          page,
          totalCount: additionalData.totalCount,
          additionalData,
        };
      }

      if (prevPage === page) {
        return prevState;
      }

      const expectedNextPage = prevPage + 1;

      if (page !== expectedNextPage) {
        console.error(`Pagination error. Expected next page: ${expectedNextPage}, received: ${page}`);
      }

      return {
        parameters,
        items: [...prevState.items, ...items],
        page,
        totalCount: additionalData.totalCount,
        additionalData,
      };
    }

    if (page !== 1) {
      console.error(`Pagination error. Parameters changed, expected next page: 1, received: ${page}`);
    }

    return {
      parameters,
      items,
      page,
      totalCount: additionalData.totalCount,
      additionalData,
    };
  };
